import { UiService } from 'app/shared/services/ui/ui.service';
import { GoogleLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { fadeAnimation } from './shared/animations/route-animations';
import { MainMenu } from './shared/models/class/menu/menu';
import { AuthService } from './shared/services/auth/auth.service';
import { DataService } from './shared/services/data/data.service';
import { FaiconService } from './shared/services/faicon/faicon.service';
import { MenuService } from './shared/services/menu/menu.service';
import { WishlistService } from './shared/services/wishlist/wishlist.service';
import { SubscriptionBaseComponent } from './shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeAnimation]

})
export class AppComponent extends SubscriptionBaseComponent implements OnInit {
  isAuth: boolean;
  showFiller = false;
  mainMenu: MainMenu[];
  showProduce: boolean;
  appVersion: string;

  private static DEMO_THEME_CLASS = 'demo';
  private static DEMO_THEME_LIGHT = 'light';
  private static DEMO_THEME_DARK = 'dark';

  public theme: string;

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private wishlistService: WishlistService,
    private menuService: MenuService,
    private route: ActivatedRoute,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private faIconService: FaiconService,
    private socialAuthService: SocialAuthService,
    private uiSrv: UiService,
    @Inject(DOCUMENT) private document: Document) {
    super();
    this.theme = this.document.documentElement.classList.contains(AppComponent.DEMO_THEME_CLASS) ?
      AppComponent.DEMO_THEME_DARK : AppComponent.DEMO_THEME_LIGHT;

  }

  ngOnInit(): void {
    if (environment.name === 'qual') {
      AppComponent.DEMO_THEME_CLASS = 'qual';
      AppComponent.DEMO_THEME_LIGHT = 'qual';
      AppComponent.DEMO_THEME_DARK = 'qual';
      this.theme = 'qual';
    }
    this.appVersion = environment.version;
    this.initComponent();
    if (this.isAuth) {
      this.getWishlist();
    }
    this.initSub();
  }


  resetPopUp(): void {
    this.dataService.popUpShop.next(false);
    this.dataService.popUpSignIn.next(false);
  }

  getRouteNavigate(url: string) {
    switch (url) {
      case '/home':
        const urlInSessionStorage = sessionStorage.getItem('route');
        sessionStorage.getItem('route') ?
          this.router.navigateByUrl(urlInSessionStorage) :
          this.router.navigate([url]);
        break;

      default:
        this.router.navigate([url]);
        break;
    }
  }

  getHeader(): boolean {
    return this.router.url.search('iframe') !== -1 ? false : true;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  private selectDarkTheme(): void {
    this.document.documentElement.classList.add(AppComponent.DEMO_THEME_CLASS);
    this.dataService.themeDemo$.next(true);
    this.theme = AppComponent.DEMO_THEME_DARK;
  }

  private selectLightTheme(): void {
    this.document.documentElement.classList.remove(AppComponent.DEMO_THEME_CLASS);
    this.dataService.themeDemo$.next(false);
    this.theme = AppComponent.DEMO_THEME_LIGHT;
  }

  private getWishlist(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.wishlistService.getWishList(+userKey).subscribe({
      next: wishes => this.dataService.myWishes.next(wishes)
    });
  }

  private userIsDemo(): void {
    this.authService.userIsDemo();
  }

  private initComponent(): void {
    this.isAuth = this.authService.isAuth();
    this.mainMenu = this.menuService.mainMenu;

    this.route.queryParams.subscribe({
      next: param => {
        if ((param.universe || param.structure) && this.router.url.includes('/home?')) {
          sessionStorage.setItem('route', this.router.url);
        }
      }
    });

    if (sessionStorage.getItem('route')) {
      const universe = +sessionStorage.getItem('route')?.split('?')[1]?.split('&')[0]?.split('=')[1];
      universe === 5 ?
        (this.dataService.themeDemo$.next(true), this.selectDarkTheme()) :
        (this.dataService.themeDemo$.next(false), this.selectLightTheme());
    }

    this.userIsDemo();

  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.showIcons$.subscribe({
          next: showProduce => {
            this.showProduce = showProduce;
            this.cdr.detectChanges();
          }
        })
      );

    this.subscription.add(
      this.socialAuthService.authState.subscribe((user) => {
        if (user && user?.provider === ('GOOGLE')) {

          this.authService.loginSocial(user.authToken, user.id, 'google', user.email).subscribe(res => {
            this.authService.isAuthWithGoogle.next(true);
            const userInfos = this.authService.getDecodedToken();
          },
            err => {
              if (err.error.error === 'invalid_grant') {
                this.authService.errorNoAccountGoogle.next(user);
              } else if (err.error.error === "invalid_request") {
                this.uiSrv.showSnackbar("Connexion impossible. Veuillez réessayer.");
              }
            });
        }
      })
    )
  }
}
